const getOperation = ({ isResale, isRetail }) => {
  if (isResale && isRetail) return 'Hibrido';
  if (!isResale && isRetail) return 'Varejo';
  if (isResale && !isRetail) return 'VD';
  if (!isResale && !isRetail) return 'Não Definida';
};

export const initialState = {
  refEmpresa: '',
  empresas: [],
  modalEmpresa: false,
  modalEmpresaVd: false,
  source: '',
  valuesToEdit: {},
  valuesToEditEstrutura: {}
};

export const mutations = {
  setEmpresas(state, payload) {
    state.empresas = payload;
  },
  handleFilterByOperation(state, payload) {
    const filter = state.empresas.filter(e => e.operacao !== payload);
    state.empresas = filter;
  },
  handleOpenModalEmpresas(state, payload) {
    state.modalEmpresa = payload;
  },
  handleOpenModalVd(state, payload) {
    state.modalEmpresaVd = payload;
  },
  setValuesToEdit(state, payload) {
    state.valuesToEdit = payload;
  },
  setSource(state, payload) {
    state.source = payload;
  },
  setReferenceEmpresa(state, payload) {
    state.refEmpresa = payload;
  }
};

export const actions = {
  async getEmpresas(context) {
    const response = await R.Empresa.todas();
    const empresas = response.data.map(e => {
      return { nome: e.nomeFantasia, operacao: getOperation(e), ...e };
    });
    context.commit('setEmpresas', empresas);
  },
  novaEstrutura(context, payload) {
    if (payload) {

    }
    context.commit('handleOpenModalVd', true);
    context.commit('setValuesToEdit', {});
  }
};

export const getters = {
};

export default {
  state: initialState,
  mutations: {
    ...mutations
  },
  getters: {
    ...getters
  },
  actions: {
    ...actions
  }
};
